import FollowWrap from "./follow-wrap";

export default FollowWrap;